"use strict";

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sigutil = __importStar(require("eth-sig-util"));

var addHexPrefix_1 = __importDefault(require("./addHexPrefix"));

var hashTypedDataV1 = function hashTypedDataV1(msgParams) {
  return addHexPrefix_1.default(sigutil.typedSignatureHash(msgParams).toString('hex'));
};

exports.default = hashTypedDataV1;